import { actions } from "./Reducer";
/**
 * Actions that fire saga watchers
 */

// Singular
export const updatePendingArtisanAction = (body) => ({
  type : actions.UPDATE_PENDING_ARTISAN,
  payload : body
})

// Plural
export const getPendingArtisansAction = (body) => ({
  type: actions.GET_PENDING_ARTISANS,
  payload: body,
});

export const getSinglePendingArtisanAction = (id) => ({
  type: actions.GET_SINGLE_PENDING_ARTISAN,
  payload: id
})

export const deleteSinglePendingArtisanAction = (id) => ({
  type: actions.DELETE_SINGLE_PENDING_ARTISAN,
  payload: id
})

export const moderateCreateSinglePendingArtisan = (id, mode) => ({
  type: actions.MODERATE_CREATE_SINGLE_PENDING_ARITSAN,
  payload: id,
  mode
})
/**
 * Actions that are fired by redux-saga watchers
*/

// Singular
export const updatePendingArtisanSuccessAction = (artisan) => ({
  type : actions.UPDATE_PENDING_ARTISAN_SUCCESS,
  payload : artisan
})

export const getSinglePendingArtisanSuccessAction = (artisan) => ({
  type: actions.GET_SINGLE_PENDING_ARTISAN_SUCCESS,
  payload: artisan
})

export const deleteSinglePendingArtisanSuccessAction = (id) => ({
  type: actions.DELETE_SINGLE_PENDING_ARTISAN_SUCCESS,
  payload: id
})

export const moderateCreateSinglePendingArtisanSuccessAction = (id) => ({
  type: actions.MODERATE_CREATE_SINGLE_PENDING_ARITSAN_SUCCESS,
  payload: id
})
// Plural
export const getPendingArtisansSuccessAction = (artisans) => ({
  type: actions.GET_PENDING_ARTISANS_SUCCESS,
  payload: artisans,
});


/**
 * Misc
 */

export const setPendingArtisansIsLoadingAction = (isLoading) => ({
  type: actions.SET_PENDING_ARTISANS_IS_LOADING,
  payload: isLoading,
});

export const setPendingArtisansCountAction = (count) => ({
  type: actions.SET_PENDING_ARTISANS_COUNT,
  payload: count,
});
